import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInHomeMode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={17}
    fill="none"
    viewBox="0 0 18 17"
    {...props}
  >
    <path
      fill="#999"
      d="M3 15V7H.5L9 0l8.5 7H15v1.5h-1.5V5.646L9 1.938 4.5 5.646V13.5h1V15zm7.833 2L7.25 13.417l1.063-1.063 2.52 2.521L15.73 10l1.042 1.042z"
    />
  </svg>
);
export default SvgInHomeMode;
